// extracted by mini-css-extract-plugin
module.exports = {"avatarTestmonial":"Testimonials_avatarTestmonial__MghKc","avatarTestmonialContainer":"Testimonials_avatarTestmonialContainer__iPa2g"};